import { BasicLayout } from '../../modules/Layouts/basicLayout'
import { Link } from 'react-router-dom'
import FormularioFiltroBitacora from './Components/BitacoraCorreos/FormularioFiltroBitacora'
import TableBitacora from './Components/BitacoraCorreos/TableBitacora'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setResetModuleBitacora } from '../../actions/bitacora/bitacora.actions'

const BitacoraCorreos = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setResetModuleBitacora());
  }, []);

  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to={'/mas-opciones'} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Bitácora de correos</h3>
      </div>
      <div className='separador'></div>
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card' style={{ height: 'auto' }}>
            <div className='w-layout-vflex card-content'>
              <FormularioFiltroBitacora />
              <TableBitacora />
            </div>
          </div>
        </div>
      </div>
    </BasicLayout>
  )
}

export default BitacoraCorreos
